@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;

.DateButton {
  @extend %form-control-border;
  @extend %form-control-font;
  @extend %form-control-disabled;

  background: $theme-color-background;
  border: none;
  cursor: pointer;
  display: inline-grid;
  padding: 0;
  white-space: nowrap;
  height: 30px;
  min-width: 15em;
  grid-template-columns: 1fr auto;
  justify-content: right;
  align-items: center;
  overflow: hidden;

  // Make a fake border since the SVG background will not fill to meet all edges?
  box-shadow: 0 0 0 1px inset $color-primary-purple;

  time {
    padding: 0 1em 0 1em;
    text-align: left;
  }

  svg {
    background: $color-primary-purple;
    color: $color-white;
    height: 30px;
    padding: 0 0.5em;
  }

  &[disabled], // disabled directly by attribute
  &:disabled {
    // within a disabled fieldset
    cursor: default !important;
    background: $color-grey-E !important;
    color: $theme-color-text !important;
    border: 1px solid $color-eggy-face !important;
  }

  &:focus,
  &:hover {
    box-shadow: 0 0 0 1px inset $color-secondary-purple;

    svg {
      background: $color-secondary-purple;
    }
  }
}
